"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUndefinedDef = void 0;
function parseUndefinedDef() {
    return {
        not: {},
    };
}
exports.parseUndefinedDef = parseUndefinedDef;
